<div class="">
  <!-- <img src="assets/landing-new/icons/star-sm.svg" class="absolute top-28 left-6 animate-blink" alt="">
  <img src="assets/landing-new/icons/star-sm.svg" class="hidden lg:block lg:absolute top-96 w-12 h-12 left-64 animate-blink" alt="">
  <img src="assets/landing-new/icons/star-lg.svg" class="hidden lg:block lg:absolute top-48 right-32 animate-blink" alt="">
   -->
  <div class="grid grid-cols-12 gap-4 lg:gap-8 relative mb-12">
    <!-- BEGIN: LEFT SIDE STEPS INFO -->
    <div class="col-span-12 lg:col-span-7 space-y-4 lg:space-y-8">
      <div class="card m-auto">
        <div class="grid grid-cols-12 gap-4">
          <div class="col-span-12">
            <h4
              class="text__yg--gradient flex font-semibold text-sm md:text-base lg:text-lg mi--font-regular lg:!leading-[1.35]"
            >
              <span class="text__yg--gradient flex">BX Explorer</span>
            </h4>
          </div>
          <!-- <div class="col-span-12 lg:col-span-6">
                      <div
                          class="flex flex-row-reverse items-center justify-between relative bg-[#1F2024] rounded-xl border-secondary-dark hover:border-primary active:border-primary focus:border-primary focus:bg-primary/30 hover:bg-primary/30 focus-within:border-primary border-2 border-solid transition ease-in-out duration-700">
                          <input type="radio" value="1" id="standard-locker" name="locker"
                              class="w-4 h-4 absolute right-4 focus:bg-[#A183E0] m-2 border-2 border-[#1F2024] focus:border-[#1F2024] focus:outline-offset-3 outline outline-[#A183E0] rounded-xl appearance-none cursor-pointer">
                          <label for="standard-locker" class="w-full h-full py-5 px-5">
                              <h2 class="font-bold text-primary-light text-base lg:text-lg 2xl:text-base">Standard Token</h2>
                          </label>
                      </div>
                  </div>
                  <div class="col-span-12 lg:col-span-6">
                      <div
                          class="flex flex-row-reverse items-center justify-between relative bg-[#1F2024] rounded-xl border-secondary-dark hover:border-primary active:border-primary focus:border-primary focus:bg-primary/30 hover:bg-primary/30 focus-within:border-primary border-2 border-solid transition ease-in-out duration-700">
                          <input type="radio" value="1" id="liquidity-locker" name="locker"
                              class="w-4 h-4 absolute right-4 focus:bg-[#A183E0] m-2 border-2 border-[#1F2024] focus:border-[#1F2024] focus:outline-offset-3 outline outline-[#A183E0] rounded-xl appearance-none cursor-pointer">
                          <label for="liquidity-locker" class="w-full h-full py-5 px-5">
                              <h2 class="font-bold text-primary-light text-base lg:text-lg 2xl:text-base">Liquidity Token</h2>
                          </label>
                      </div>
                  </div> -->
          <div class="col-span-12">
            <label for="token_contract_add" class="input--label mb-2"
              >Enter Token Address</label
            >

            <input
              [(ngModel)]="tokenAddress"
              name="token_contract_add"
              placeholder="Enter Token Contract Address"
              class="input--field"
              type="text"
            />
            <div *ngIf="isValidToken == 3" class="input--error text-sm leading-8 mb-4">
              Invalid Token Address
            </div>
            <button
              (click)="onImportTokenAddress()"
              class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-solid border-[#4e1fa3] font-medium text-white mt-8"
            >
              {{ searchButton }}
            </button>
          </div>
        </div>
      </div>


    </div>
    <div class="col-span-12 lg:col-span-5">
      <div class="card m-auto h-full">
        <h4
          class="text__yg--gradient flex font-semibold text-sm md:text-base lg:text-lg mi--font-regular lg:!leading-[1.35] pb-0"
        >
          <span class="text__yg--gradient flex">Token Info</span>
        </h4>
        <!-- <div *ngIf="isValidToken != 2" class="col-span-12">
          <h6 class="text-primary-light font-normal text-base 2xl:base">
            Enter Valid Token Address
          </h6>
        </div> -->
        <div  class="grid grid-cols-12 gap-4 mt-4">
          <!-- <div class="col-span-12 md:col-span-12">
                      <h6 class="text-primary-light font-normal text-base 2xl:base">Token Address (Do not send
                          to this token address)</h6>
                      <p class="text-[#d9d9d9] font-medium text-lg 2xl:text-xl  break-words">
                          0x5647382964738296547382965473829
                      </p>
                  </div> -->
          <div class="col-span-12 flex items-center">
            <h6 class="text-primary-light font-normal text-base 2xl:base">
              Token Name :
            </h6>
            <p class="text-[#d9d9d9] font-medium text-lg 2xl:text-xl  pl-4">
              {{ tokenInfo?.tokenName || '-'}}
            </p>
          </div>
          <div class="col-span-12 flex items-center">
            <h6 class="text-primary-light font-normal text-base 2xl:base">
              Token Symbol :
            </h6>
            <p class="text-[#d9d9d9] font-medium text-lg 2xl:text-xl  pl-4">
              {{ tokenInfo?.tokenSymbol || '-'}}
            </p>
          </div>
          <div class="col-span-12 flex items-center">
            <h6 class="text-primary-light font-normal text-base 2xl:base">
              Token Decimal :
            </h6>
            <p class="text-[#d9d9d9] font-medium text-lg 2xl:text-xl  pl-4">
              {{ tokenInfo?.tokenDecimal || '-'}}
            </p>
          </div>
          <div class="col-span-12 flex items-center">
            <h6 class="text-primary-light font-normal text-base 2xl:base">
              Total Supply :
            </h6>
            <p
              class="text-[#d9d9d9] font-medium text-lg 2xl:text-xl truncate pl-4"
              tooltipClass="tooltip-truncate"
              tooltip="{{tokenInfo?.totalSupply}}"
            >
              {{ tokenInfo?.totalSupply || '-'}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>




  <div class="grid grid-cols-12 gap-4 lg:gap-8 relative">
    <!-- BEGIN: LEFT SIDE STEPS INFO -->
    <div class="col-span-12 lg:col-span-12 space-y-4 lg:space-y-8">

      <div
        *ngIf="isValidToken == 2 && tokenInfo?.type == 'STANDARD_TOKEN'"
        class="card m-auto"
      >
        <div class="grid grid-cols-12 gap-4 lg:gap-8">
          <div class="col-span-12">
            <ul
              class="flex flex-wrap w-fit bg-[#1F2024] rounded-lg p-2"
              id="launchPadTabs"
              data-tabs-toggle="#tradeFormTabContent"
              role="tablist"
            >
              <li role="presentation">
                <button
                  (click)="setActiveMenu(0)"
                  class="{{
                    isMenuActive == 0
                      ? 'text-white bg-primary/30 border-2 border-solid border-primary'
                      : 'text-[#b1a7ca]'
                  }} font-medium text-xs lg:text-sm p-3 px-4 sm:px-8 rounded-md"
                  id="createLaunchpad"
                >
                  Read Contract
                </button>
              </li>
              <li role="presentation">
                <button
                  (click)="setActiveMenu(1)"
                  class="{{
                    isMenuActive == 1
                      ? 'text-white bg-primary/30 border-2 border-solid border-primary'
                      : 'text-[#b1a7ca]'
                  }} font-medium text-xs lg:text-sm p-3 px-4 sm:px-8 rounded-md"
                  id="listLaunchpad"
                >
                  Write Contract
                </button>
              </li>
            </ul>
            <div *ngIf="isMenuActive == 0" class="mt-8">
              <div class="grid grid-cols-12 gap-4">
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg"
                >
                  <div (click)="allowance()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      1. allowance
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isAllowanceCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >owner (address)</label
                      >
                      <input
                        [(ngModel)]="allowanceOwner"
                        name="value"
                        placeholder="owner (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>
                    <div>
                      <label for="spender" class="input--label__md mb-1"
                        >_spender (address)</label
                      >
                      <input
                        [(ngModel)]="allowanceSpendor"
                        name="spender"
                        placeholder="_spender (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>

                    <button
                      (click)="getAllowance(allowanceOwner, allowanceSpendor)"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      Query
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ tokenInfo?.allowance }}
                      </a>
                      <em>uint256</em>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="balanceOf()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      2. balanceOf
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isBalanceOfCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label
                        for="upgrade-address"
                        class="input--label__md mb-1"
                      >
                        account (address)
                      </label>
                      <input
                        [(ngModel)]="balanceOfAccount"
                        name="upgrade-address"
                        placeholder="account (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>

                    <button
                      (click)="getBalanceOf(balanceOfAccount)"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      Query
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ tokenInfo?.balance }}
                      </a>
                      <em>uint256</em>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="decimals()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      3. decimals
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isDecimalsCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <a
                      class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                    >
                      {{ tokenInfo?.tokenDecimal }}
                    </a>
                    <em> uint256</em>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="fromBx()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      4. fromBX
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isFromBxCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <p class="text-[#d9d9d9] text-sm md:text-base ep--font-light">
                      {{tokenInfo?.type}} <em>string</em>
                    </p>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="name()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      5. name
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isNameCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <p class="text-[#d9d9d9] text-sm md:text-base ep--font-light">
                      {{ tokenInfo?.tokenName }} <em>string</em>
                    </p>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="owner()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      6. owner
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isOwnerCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <a
                      (click)="openAddressExplorer(tokenInfo?.owner)"
                      class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                    >
                      {{ tokenInfo?.owner }}
                    </a>
                    <em>address</em>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="paused()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      7. paused
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isPausedCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <p class="text-[#d9d9d9] text-sm md:text-base ep--font-light">
                      False <em>bool</em>
                    </p>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="symbol()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      8. symbol
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isSymbolCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <a
                      class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                    >
                      {{ tokenInfo?.tokenSymbol }}
                    </a>
                    <em>string</em>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="totalSupply()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      9. totalSupply
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isTotalSupplyCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <a
                      class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                    >
                      {{ tokenInfo?.totalSupply }}
                    </a>
                    <em>uint256</em>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="isMenuActive == 1" class="mt-8">
              <div class="grid grid-cols-12 gap-4">
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="approve()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      1. approve
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isApproveCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="spender" class="input--label__md mb-1"
                        >spender (address)</label
                      >
                      <input
                        [(ngModel)]="approveSpender"
                        name="spender"
                        placeholder="spender (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >amount (uint256)</label
                      >
                      <input
                        [(ngModel)]="approveAmount"
                        name="value"
                        placeholder="amount (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>
                    <button
                      (click)="
                        setFunctionError(0);
                        writeApprove(approveSpender, approveAmount)
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[0]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[0]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[0] }}
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="burn()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      2. burn
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isBurnCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <div>
                      <label for="upgrade-address" class="input--label__md mb-1"
                        >amount (uint256)</label
                      >
                      <input
                        [(ngModel)]="burnAmount"
                        name="upgrade-address"
                        placeholder="amount (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>
                    <button
                      (click)="setFunctionError(1); writeBurn(burnAmount)"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[1]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[1]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[1] }}
                      </a>
                    </div>
                  </div>
                </div>

                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="burnFrom()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      3. burnFrom
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isBurnFromCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >account (address)</label
                      >
                      <input
                        [(ngModel)]="burnFromAccount"
                        name="value"
                        placeholder="account (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>
                    <div>
                      <label for="spender" class="input--label__md mb-1"
                        >amount (uint256)</label
                      >
                      <input
                        [(ngModel)]="accountBurnAmount"
                        name="spender"
                        placeholder="amount (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>
                    <button
                      (click)="
                        setFunctionError(2);
                        writeBunFrom(burnFromAccount, accountBurnAmount)
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[2]}}
                    </button>

                    <button
                      *ngIf="showViewTransaction[2]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[2] }}
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="decreaseAllowance()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      4. decreaseAllowance
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isDecreaseAllowanceCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >spender (address)</label
                      >
                      <input
                        [(ngModel)]="decreaseAllowanceSpender"
                        name="value"
                        placeholder="spender (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>
                    <div>
                      <label for="spender" class="input--label__md mb-1"
                        >subtractedValue (uint256)</label
                      >
                      <input
                        [(ngModel)]="decreaseAllowanceAmount"
                        name="spender"
                        placeholder="subtractedValue (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>
                    <button
                      (click)="
                        setFunctionError(3);
                        writeDecreaseAllowance(
                          decreaseAllowanceSpender,
                          decreaseAllowanceAmount
                        )
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[3]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[3]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[3] }}
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="increaseAllowance()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      5. increaseAllowance
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isIncreaseAllowanceCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >spender (address)</label
                      >
                      <input
                        [(ngModel)]="increaseAllowanceSpender"
                        name="value"
                        placeholder="spender (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>
                    <div>
                      <label for="spender" class="input--label__md mb-1"
                        >addedValue (uint256)</label
                      >
                      <input
                        [(ngModel)]="increaseAllowanceAmount"
                        name="spender"
                        placeholder="addedValue (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>
                    <button
                      (click)="
                        setFunctionError(4);
                        writeIncreaseAllowance(
                          increaseAllowanceSpender,
                          increaseAllowanceAmount
                        )
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[4]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[4]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[4] }}
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="mint()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      6. mint
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isMintCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <div>
                      <label for="upgrade-address" class="input--label__md mb-1"
                        >amount (uint256)</label
                      >
                      <input
                        [(ngModel)]="mintAmount"
                        name="upgrade-address"
                        placeholder="amount (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>
                    <button
                      (click)="setFunctionError(5); writeMint(mintAmount)"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[5]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[5]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[5] }}
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="pause()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      7. pause
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isPauseCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <button
                      (click)="setFunctionError(6); writePause()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[6]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[6]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[6] }}
                      </a>
                    </div>
                  </div>
                </div>

                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="renounceOwnership()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      8. renounceOwnership
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isRenounceOwnershipCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <button
                      (click)="setFunctionError(7); writeRenounceOwnership()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[7]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[7]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[7] }}
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="transfer()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      9. transfer
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!istransferCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="to-address" class="input--label__md mb-1"
                        >to (address)</label
                      >
                      <input
                        [(ngModel)]="transferToAddress"
                        name="to-address"
                        placeholder="_to (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >value (uint256)</label
                      >
                      <input
                        [(ngModel)]="transferToAmount"
                        name="value"
                        placeholder="_value (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>
                    <button
                      (click)="
                        setFunctionError(8);
                        writeTransfer(transferToAddress, transferToAmount)
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[8]}}
                    </button>

                    <button
                      *ngIf="showViewTransaction[8]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[8] }}
                      </a>
                    </div>
                  </div>
                </div>

                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="transferFrom()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      10. transferFrom
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!istransferFromCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="spender" class="input--label__md mb-1"
                        >from (address)</label
                      >
                      <input
                        [(ngModel)]="transferFromFromAddress"
                        name="spender"
                        placeholder="from (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>
                    <div>
                      <label for="spender" class="input--label__md mb-1"
                        >to (address)</label
                      >
                      <input
                        [(ngModel)]="transferFromToAddress"
                        name="spender"
                        placeholder="to (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>
                    <div>
                      <label for="spender" class="input--label__md mb-1"
                        >amount (uint256)</label
                      >
                      <input
                        [(ngModel)]="transferFromAmount"
                        name="spender"
                        placeholder="amount (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>
                    <button
                      (click)="
                        setFunctionError(9);
                        writeTransferFrom(
                          transferFromFromAddress,
                          transferFromToAddress,
                          transferFromAmount
                        )
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[9]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[9]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[9] }}
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="transferOwnership()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      11. transferOwnership
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isTransferOwnershipCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="spender" class="input--label__md mb-1"
                        >to (address)</label
                      >
                      <input
                        [(ngModel)]="transferOwnershipAddress"
                        name="spender"
                        placeholder="to (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>

                    <button
                      (click)="
                        setFunctionError(10);
                        writeTransferOwnership(transferOwnershipAddress)
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[10]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[10]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[10] }}
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="unpause()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      12. unpause
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isUnpauseCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <button
                      (click)="setFunctionError(11); writeUnPause()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[11]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[11]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[11] }}
                      </a>
                    </div>
                  </div>
                </div>

                <!-- <div  *ngFor="let fun of readFunction;index as i"
                              class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700">
                              <div class="flex justify-between">
                                  <h2 class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg">{{fun}}
                                  </h2>
                                  <img src="assets/landing-new/icons/arrow-right-violet.svg" class="cursor-pointer"
                                      alt="">
                              </div>
                              <div [@collapse]="i==i"
                                      class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider">
                                      <div>
                                          <label for="amount" class="input--label__md mb-1">_blackListedUser
                                              (address)</label>
                                          <input name="amount" placeholder="_blackListedUser (address)"
                                              class="input--field__md" type="text">
                                      </div>
                                      <button
                                          class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4">Write</button>
                                  </div>

                          </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="isValidToken == 2 && tokenInfo?.type == 'LIQUIDITY_TOKEN'"
        class="card m-auto"
      >
        <div class="grid grid-cols-12 gap-4 lg:gap-8">
          <div class="col-span-12">
            <ul
              class="flex flex-wrap w-fit bg-[#1F2024] rounded-lg p-2"
              id="launchPadTabs"
              data-tabs-toggle="#tradeFormTabContent"
              role="tablist"
            >
              <li role="presentation">
                <button
                  (click)="setActiveMenu(0)"
                  class="{{
                    isMenuActive == 0
                      ? 'text-white bg-primary/30 border-2 border-solid border-primary'
                      : 'text-[#b1a7ca]'
                  }} font-medium text-xs lg:text-sm p-3 px-4 sm:px-8 rounded-md"
                  id="createLaunchpad"
                >
                  Read Contract
                </button>
              </li>
              <li role="presentation">
                <button
                  (click)="setActiveMenu(1)"
                  class="{{
                    isMenuActive == 1
                      ? 'text-white bg-primary/30 border-2 border-solid border-primary'
                      : 'text-[#b1a7ca]'
                  }} font-medium text-xs lg:text-sm p-3 px-4 sm:px-8 rounded-md"
                  id="listLaunchpad"
                >
                  Write Contract
                </button>
              </li>
            </ul>
            <div *ngIf="isMenuActive == 0" class="mt-8">
              <div class="grid grid-cols-12 gap-4">
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="DEFAULT_ADMIN_ROLE()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      1. DEFAULT_ADMIN_ROLE
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isDEFAULT_ADMIN_ROLECollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <a
                      class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                    >
                      {{ tokenInfo?.default_admin_role }}
                    </a>
                    <em> byte32</em>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="LIQUIDITY_GENERATOR_ROLE()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      2. LIQUIDITY_GENERATOR_ROLE
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isLIQUIDITY_GENERATOR_ROLECollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <a
                      class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                    >
                      {{ tokenInfo?.liquidity_generator_role }}
                    </a>
                    <em> byte32</em>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg"
                >
                  <div (click)="allowance()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      3. allowance
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isAllowanceCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >owner (address)</label
                      >
                      <input
                        [(ngModel)]="allowanceOwner"
                        name="value"
                        placeholder="owner (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>
                    <div>
                      <label for="spender" class="input--label__md mb-1"
                        >_spender (address)</label
                      >
                      <input
                        [(ngModel)]="allowanceSpendor"
                        name="spender"
                        placeholder="_spender (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>

                    <button
                      (click)="getAllowance(allowanceOwner, allowanceSpendor)"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      Query
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ tokenInfo?.allowance }}
                      </a>
                      <em>uint256</em>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="balanceOf()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      4. balanceOf
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isBalanceOfCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label
                        for="upgrade-address"
                        class="input--label__md mb-1"
                      >
                        account (address)
                      </label>
                      <input
                        [(ngModel)]="balanceOfAccount"
                        name="upgrade-address"
                        placeholder="account (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>

                    <button
                      (click)="getBalanceOf(balanceOfAccount)"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      Query
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ tokenInfo?.balance }}
                      </a>
                      <em>uint256</em>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="charityAddress()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      5. charityAddress
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!ischarityAddressCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <a
                      (click)="openAddressExplorer(tokenInfo?.charityAddress)"
                      class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                    >
                      {{ tokenInfo?.charityAddress }}
                    </a>
                    <em> address</em>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="charityFee()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      6. charityFee
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!ischarityFeeCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <a
                      class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                    >
                      {{ tokenInfo?.charityFee }}
                    </a>
                    <em> uint256</em>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="charityFeeBalance()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      7. charityFeeBalance
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!ischarityFeeBalanceCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <a
                      class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                    >
                      {{ tokenInfo?.charityFeeBalance }}
                    </a>
                    <em> uint256</em>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="charityFeeToSell()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      8. charityFeeToSell
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!ischarityFeeToSellCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <a
                      class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                    >
                      {{ tokenInfo?.charityFeeToSell }}
                    </a>
                    <em> uint256</em>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="decimals()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      9. decimals
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isDecimalsCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <a
                      class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                    >
                      {{ tokenInfo?.tokenDecimal }}
                    </a>
                    <em> uint256</em>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="enableFee()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      10. enableFee
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isenableFeeCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <a
                      class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                    >
                      {{ tokenInfo?.enableFee }}
                    </a>
                    <em> bool</em>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="enableMaxTransactionAmount()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      11. enableMaxTransactionAmount
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isenableMaxTransactionAmountCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <a
                      class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                    >
                      {{ tokenInfo?.enableMaxTransactionAmount }}
                    </a>
                    <em> bool</em>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="fromBx()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      12. fromBX
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isFromBxCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <p class="text-[#d9d9d9] text-sm md:text-base ep--font-light">
                      {{tokenInfo?.type}}  <em>string</em>
                    </p>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="getRoleAdmin()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      13. getRoleAdmin
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isgetRoleAdminCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label
                        for="upgrade-address"
                        class="input--label__md mb-1"
                      >
                        role (byte32)
                      </label>
                      <input
                        [(ngModel)]="roleAdminByte"
                        name="upgrade-address"
                        placeholder="role (byte32)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>

                    <button
                      (click)="readGetRoleAdmin(roleAdminByte)"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      Query
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ tokenInfo?.balance }}
                      </a>
                      <em>byte32</em>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="hasRole()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      14. hasRole
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!ishasRoleCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label
                        for="upgrade-address"
                        class="input--label__md mb-1"
                      >
                        role (byte32)
                      </label>
                      <input
                        [(ngModel)]="hasRoleByte"
                        name="upgrade-address"
                        placeholder="role (byte32)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>
                    <div>
                      <label
                        for="upgrade-address"
                        class="input--label__md mb-1"
                      >
                        account (address)
                      </label>
                      <input
                        [(ngModel)]="hasRoleAccount"
                        name="upgrade-address"
                        placeholder="account (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>

                    <button
                      (click)="readHasRole(hasRoleByte, hasRoleAccount)"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      Query
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ tokenInfo?.hasRole }}
                      </a>
                      <em>bool</em>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="isExcludedFromDexFee()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      15. isExcludedFromDexFee
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isExcludedFromDexFeeCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label
                        for="upgrade-address"
                        class="input--label__md mb-1"
                      >
                        account (address)
                      </label>
                      <input
                        [(ngModel)]="isExcludedFromDexFeeAddress"
                        name="upgrade-address"
                        placeholder="account (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>

                    <button
                      (click)="
                        readIsExcludedFromDexFee(isExcludedFromDexFeeAddress)
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      Query
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ tokenInfo?.isExcludedFromDexFee }}
                      </a>
                      <em>bool</em>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="isExcludedFromReward()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      16. isExcludedFromReward
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isExcludedFromRewardCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label
                        for="upgrade-address"
                        class="input--label__md mb-1"
                      >
                        account (address)
                      </label>
                      <input
                        [(ngModel)]="isExcludedFromRewardAddress"
                        name="upgrade-address"
                        placeholder="account (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>

                    <button
                      (click)="
                        readisExcludedFromReward(isExcludedFromRewardAddress)
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      Query
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ tokenInfo?.isExcludedFromReward }}
                      </a>
                      <em>bool</em>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="liquidityFee()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      17. liquidityFee
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isliquidityFeeCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <a
                      class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                    >
                      {{ tokenInfo?.liquidityFee }}
                    </a>
                    <em> uint256</em>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="liquidityFeeBalance()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      18. liquidityFeeBalance
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isliquidityFeeBalanceCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <a
                      class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                    >
                      {{ tokenInfo?.liquidityFeeBalance }}
                    </a>
                    <em> uint256</em>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="liquidityFeeToSell()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      19. liquidityFeeToSell
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isliquidityFeeToSellCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <a
                      class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                    >
                      {{ tokenInfo?.liquidityFeeToSell }}
                    </a>
                    <em> uint256</em>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="marketingAddress()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      20. marketingAddress
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!ismarketingAddressCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <a
                      (click)="openAddressExplorer(tokenInfo?.marketingAddress)"
                      class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                    >
                      {{ tokenInfo?.marketingAddress }}
                    </a>
                    <em> address</em>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="marketingFee()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      21. marketingFee
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!ismarketingFeeCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <a
                      class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                    >
                      {{ tokenInfo?.marketingFee }}
                    </a>
                    <em> uint256</em>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="marketingFeeBalance()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      22. marketingFeeBalance
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!ismarketingFeeBalanceCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <a
                      class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                    >
                      {{ tokenInfo?.marketingFeeBalance }}
                    </a>
                    <em> uint256</em>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="marketingFeeToSell()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      23. marketingFeeToSell
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!ismarketingFeeToSellCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <a
                      class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                    >
                      {{ tokenInfo?.marketingFeeToSell }}
                    </a>
                    <em> uint256</em>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="name()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      24. name
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isNameCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <p class="text-[#d9d9d9] text-sm md:text-base ep--font-light">
                      {{ tokenInfo?.tokenName }} <em>string</em>
                    </p>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="owner()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      25. owner
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isOwnerCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <a
                      (click)="openAddressExplorer(tokenInfo?.owner)"
                      class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                    >
                      {{ tokenInfo?.owner }}
                    </a>
                    <em>address</em>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="paused()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      26. paused
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isPausedCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <p class="text-[#d9d9d9] text-sm md:text-base ep--font-light">
                      {{ tokenInfo?.isPaused }} <em>bool</em>
                    </p>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="reflectionFee()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      27. reflectionFee
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isreflectionFeeCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <a
                      class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                    >
                      {{ tokenInfo?.reflectionFee }}
                    </a>
                    <em> uint256</em>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="supportInterface()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      28. supportInterface
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!issupportInterfaceCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label
                        for="upgrade-address"
                        class="input--label__md mb-1"
                      >
                        role (byte4)
                      </label>
                      <input
                        [(ngModel)]="supportInterfaceId"
                        name="upgrade-address"
                        placeholder="role (byte4)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>

                    <button
                      (click)="readSupportInterface(supportInterfaceId)"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      Query
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ tokenInfo?.supportInterface }}
                      </a>
                      <em>bool</em>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="swapAndLiquifyEnabled()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      29. swapAndLiquifyEnabled
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isswapAndLiquifyEnabledCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <a
                      class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                    >
                      {{ tokenInfo?.swapAndLiquifyEnabled }}
                    </a>
                    <em>bool</em>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="symbol()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      30. symbol
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isSymbolCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <a
                      class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                    >
                      {{ tokenInfo?.tokenSymbol }}
                    </a>
                    <em>string</em>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="tokenFromReflection()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      31. tokenFromReflection
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!istokenFromReflectionCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label
                        for="upgrade-address"
                        class="input--label__md mb-1"
                      >
                        rAmount (uint256)
                      </label>
                      <input
                        [(ngModel)]="tokenFromReflectionAmount"
                        name="upgrade-address"
                        placeholder="rAmount (uint256)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>

                    <button
                      (click)="
                        readtokenFromReflection(tokenFromReflectionAmount)
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      Query
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ tokenInfo?.tokenFromReflection }}
                      </a>
                      <em>uint256</em>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="totalFees()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      32. totalFees
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!istotalFeesCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <a
                      class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                    >
                      {{ tokenInfo?.totalFees }}
                    </a>
                    <em>uint256</em>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="totalSupply()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      33. totalSupply
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isTotalSupplyCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <a
                      class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                    >
                      {{ tokenInfo?.totalSupply }}
                    </a>
                    <em>uint256</em>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="transactionLimit()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      34. transactionLimit
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!istransactionLimitCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <a
                      class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                    >
                      {{ tokenInfo?.transactionLimit }}
                    </a>
                    <em>uint256</em>
                  </div>
                </div>

                <!-- <div
          class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700">
          <div (click)="transactionLimit()" class="flex justify-between">
              <h2 class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg">34. transactionLimit </h2>
              <img src="assets/landing-new/icons/arrow-right-violet.svg" class="cursor-pointer"
                  alt="">
          </div>
          <div [@collapse]="!istransactionLimitCollapsed"
              class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide">
              <a
                  class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block">
                  {{tokenInfo?.transactionLimit}}
              </a>
              <em>uint256</em>
          </div>
      </div> -->

                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="uniswapV2Pair()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      35. uniswapV2Pair
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isuniswapV2PairCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <a
                      (click)="openAddressExplorer(tokenInfo?.uniswapV2Pair)"
                      class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                    >
                      {{ tokenInfo?.uniswapV2Pair }}
                    </a>
                    <em>address</em>
                  </div>
                </div>

                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="uniswapV2Router()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      36. uniswapV2Router
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isuniswapV2RouterCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <a
                      (click)="openAddressExplorer(tokenInfo?.uniswapV2Router)"
                      class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                    >
                      {{ tokenInfo?.uniswapV2Router }}
                    </a>
                    <em>address</em>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="isMenuActive == 1" class="mt-8">
              <div class="grid grid-cols-12 gap-4">
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="approve()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      1. approve
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isApproveCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="spender" class="input--label__md mb-1"
                        >spender (address)</label
                      >
                      <input
                        [(ngModel)]="approveSpender"
                        name="spender"
                        placeholder="spender (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >amount (uint256)</label
                      >
                      <input
                        [(ngModel)]="approveAmount"
                        name="value"
                        placeholder="amount (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>
                    <button
                      (click)="
                        setFunctionError(0);
                        writeApprove(approveSpender, approveAmount)
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[0]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[0]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[0] }}
                      </a>
                    </div>
                  </div>
                </div>

                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="decreaseAllowance()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      2. decreaseAllowance
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isDecreaseAllowanceCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >spender (address)</label
                      >
                      <input
                        [(ngModel)]="decreaseAllowanceSpender"
                        name="value"
                        placeholder="spender (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>
                    <div>
                      <label for="spender" class="input--label__md mb-1"
                        >subtractedValue (uint256)</label
                      >
                      <input
                        [(ngModel)]="decreaseAllowanceAmount"
                        name="spender"
                        placeholder="subtractedValue (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>
                    <button
                      (click)="
                        setFunctionError(1);
                        writeDecreaseAllowance(
                          decreaseAllowanceSpender,
                          decreaseAllowanceAmount
                        )
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[1]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[1]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[1] }}
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="excludeFromDexFee()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      3. excludeFromDexFee
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isexcludeFromDexFeeCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >account (address)</label
                      >
                      <input
                        [(ngModel)]="excludeFromDexFeeAddress"
                        name="value"
                        placeholder="account (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>

                    <button
                      (click)="
                        setFunctionError(2);
                        writeExcludeFromDexFee(excludeFromDexFeeAddress)
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[2]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[2]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[2] }}
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="excludeFromReward()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      4. excludeFromReward
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isexcludeFromDexRewardAddressCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >account (address)</label
                      >
                      <input
                        [(ngModel)]="excludeFromDexRewardAddress"
                        name="value"
                        placeholder="account (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>

                    <button
                      (click)="
                        setFunctionError(3);
                        writeExcludeFromReward(excludeFromDexRewardAddress)
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[3]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[3]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[3] }}
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="grantRole()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      5. grantRole
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isgrantRoleCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >role (byte32)</label
                      >
                      <input
                        [(ngModel)]="grantRoleByte"
                        name="value"
                        placeholder="role (byte32)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >account (address)</label
                      >
                      <input
                        [(ngModel)]="grantRoleAddress"
                        name="value"
                        placeholder="spender (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>

                    <button
                      (click)="
                        setFunctionError(4);
                        writeGrantRole(grantRoleByte, grantRoleAddress)
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[4]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[4]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[4] }}
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="includeInDexFee()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      6. includeInDexFee
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isincludeInDexFeeCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >account (address)</label
                      >
                      <input
                        [(ngModel)]="includeInDexFeeAddress"
                        name="value"
                        placeholder="account (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>

                    <button
                      (click)="
                        setFunctionError(5);
                        writeIncludeInDexFee(includeInDexFeeAddress)
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[5]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[5]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[5] }}
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="includeInDexReward()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      7. includeInDexReward
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isincludeInDexRewardCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >account (address)</label
                      >
                      <input
                        [(ngModel)]="includeInDexRewardAddress"
                        name="value"
                        placeholder="account (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>

                    <button
                      (click)="
                        setFunctionError(6);
                        writeIncludeInDexReward(includeInDexRewardAddress)
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[6]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[6]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[6] }}
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="increaseAllowance()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      8. increaseAllowance
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isIncreaseAllowanceCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >spender (address)</label
                      >
                      <input
                        [(ngModel)]="increaseAllowanceSpender"
                        name="value"
                        placeholder="spender (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>
                    <div>
                      <label for="spender" class="input--label__md mb-1"
                        >addedValue (uint256)</label
                      >
                      <input
                        [(ngModel)]="increaseAllowanceAmount"
                        name="spender"
                        placeholder="addedValue (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>
                    <button
                      (click)="
                        setFunctionError(7);
                        writeIncreaseAllowance(
                          increaseAllowanceSpender,
                          increaseAllowanceAmount
                        )
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[7]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[7]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[7] }}
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="pause()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      9. pauseContract
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isPauseCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <button
                      (click)="setFunctionError(8); writePauseContract()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[8]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[8]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[8] }}
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="renounceOwnership()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      10. renounceOwnership
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isRenounceOwnershipCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <button
                      (click)="setFunctionError(9); writeRenounceOwnership()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[9]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[9]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[9] }}
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="renounceRole()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      11. renounceRole
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isrenounceRoleCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >role (byte32)</label
                      >
                      <input
                        [(ngModel)]="renounceRoleByte"
                        name="value"
                        placeholder="role (byte32)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >account (address)</label
                      >
                      <input
                        [(ngModel)]="renounceRoleAddress"
                        name="value"
                        placeholder="account (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>

                    <button
                      (click)="
                        setFunctionError(10);
                        writeRenounceRole(renounceRoleByte, renounceRoleAddress)
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[10]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[10]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[10] }}
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="revokeRole()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      12. revokeRole
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isrevokeRoleCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >role (byte32)</label
                      >
                      <input
                        [(ngModel)]="revokeRoleByte"
                        name="value"
                        placeholder="role (byte32)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >account (address)</label
                      >
                      <input
                        [(ngModel)]="revokeRoleAddress"
                        name="value"
                        placeholder="account (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>

                    <button
                      (click)="
                        setFunctionError(11);
                        writeRevokeRole(revokeRoleByte, revokeRoleAddress)
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[11]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[11]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[11] }}
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="setValues()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      13. setValues
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!issetValuesCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >_reflectionFee (uint256)</label
                      >
                      <input
                        [(ngModel)]="setValue_refectionFee"
                        name="value"
                        placeholder="_reflectionFee (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >_liquidityFee (uint256)</label
                      >
                      <input
                        [(ngModel)]="setValue_liquidityFee"
                        name="value"
                        placeholder="_liquidityFee (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >_liquidityFeeToSell (uint256)</label
                      >
                      <input
                        [(ngModel)]="setValue_liquidityFeeToSell"
                        name="value"
                        placeholder="_liquidityFeeToSell (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >_marketingFee (uint256)</label
                      >
                      <input
                        [(ngModel)]="setValue_marketingFee"
                        name="value"
                        placeholder="_marketingFee (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >_marketingFeeToSell (uint256)</label
                      >
                      <input
                        [(ngModel)]="setValue_marketingFeeToSell"
                        name="value"
                        placeholder="_marketingFeeToSell (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >_marketingAddress (address)</label
                      >
                      <input
                        [(ngModel)]="setValue_marketingAddress"
                        name="value"
                        placeholder="_marketingAddress (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >_charityFee (uint256)</label
                      >
                      <input
                        [(ngModel)]="setValue_charityFee"
                        name="value"
                        placeholder="_charityFee (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >_charityFeeToSell (uint256)</label
                      >
                      <input
                        [(ngModel)]="setValue_charityFeeToSell"
                        name="value"
                        placeholder="_charityFeeToSell (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >_charityAddress (address)</label
                      >
                      <input
                        [(ngModel)]="setValue_charityAddress"
                        name="value"
                        placeholder="_charityAddress (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >_trasactionLimit (uint256)</label
                      >
                      <input
                        [(ngModel)]="setValue_trasactionLimit"
                        name="value"
                        placeholder="_trasactionLimit (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>

                    <button
                      (click)="
                        setFunctionError(12);
                        writeSetValues(
                          setValue_refectionFee,
                          setValue_liquidityFee,
                          setValue_liquidityFeeToSell,
                          setValue_marketingFee,
                          setValue_marketingFeeToSell,
                          setValue_marketingAddress,
                          setValue_charityFee,
                          setValue_charityFeeToSell,
                          setValue_charityAddress,
                          setValue_trasactionLimit
                        )
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[12]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[12]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[12] }}
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="transfer()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      14. transfer
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!istransferCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="to-address" class="input--label__md mb-1"
                        >to (address)</label
                      >
                      <input
                        [(ngModel)]="transferToAddress"
                        name="to-address"
                        placeholder="_to (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >value (uint256)</label
                      >
                      <input
                        [(ngModel)]="transferToAmount"
                        name="value"
                        placeholder="_value (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>
                    <button
                      (click)="
                        setFunctionError(13);
                        writeTransfer(transferToAddress, transferToAmount)
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[13]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[13]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[13] }}
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="transferFrom()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      15. transferFrom
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!istransferFromCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="spender" class="input--label__md mb-1"
                        >from (address)</label
                      >
                      <input
                        [(ngModel)]="transferFromFromAddress"
                        name="spender"
                        placeholder="from (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>
                    <div>
                      <label for="spender" class="input--label__md mb-1"
                        >to (address)</label
                      >
                      <input
                        [(ngModel)]="transferFromToAddress"
                        name="spender"
                        placeholder="to (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>
                    <div>
                      <label for="spender" class="input--label__md mb-1"
                        >amount (uint256)</label
                      >
                      <input
                        [(ngModel)]="transferFromAmount"
                        name="spender"
                        placeholder="amount (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>
                    <button
                      (click)="
                        setFunctionError(14);
                        writeTransferFrom(
                          transferFromFromAddress,
                          transferFromToAddress,
                          transferFromAmount
                        )
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[14]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[14]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[14] }}
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="transferOwnership()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      16. transferOwnership
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isTransferOwnershipCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="spender" class="input--label__md mb-1"
                        >to (address)</label
                      >
                      <input
                        [(ngModel)]="transferOwnershipAddress"
                        name="spender"
                        placeholder="to (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>

                    <button
                      (click)="
                        setFunctionError(15);
                        writeTransferOwnership(transferOwnershipAddress)
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[15]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[15]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[15] }}
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="unpause()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      17. unPauseContract
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isUnpauseCollapsed"
                    class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide"
                  >
                    <button
                      (click)="setFunctionError(16); writeUnPauseContract()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[16]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[16]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[16] }}
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="updateCharityAddress()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      18. updateCharityAddress
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isupdateCharityAddressCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >account (address)</label
                      >
                      <input
                        [(ngModel)]="updateCharityAddressAddress"
                        name="value"
                        placeholder="account (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>

                    <button
                      (click)="
                        setFunctionError(17);
                        writeUpdateCharityAddress(updateCharityAddressAddress)
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[17]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[17]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[17] }}
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="updateCharityFee()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      19. updateCharityFee
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isupdateCharityFeeCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >feeInPercentage (uint256)</label
                      >
                      <input
                        [(ngModel)]="updateCharityFeeAmount"
                        name="value"
                        placeholder="feeInPercentage (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>

                    <button
                      (click)="
                        setFunctionError(18);
                        writeUpdateCharityFee(updateCharityFeeAmount)
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[18]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[18]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[18] }}
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="updateCharityFeeToSell()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      20. updateCharityFeeToSell
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isupdateCharityFeeToSellCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >charityFeeToSell (uint256)</label
                      >
                      <input
                        [(ngModel)]="updateCharityFeeToSellAmount"
                        name="value"
                        placeholder="charityFeeToSell (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>

                    <button
                      (click)="
                        setFunctionError(19);
                        writeUpdateCharityFeeToSellAmount(
                          updateCharityFeeToSellAmount
                        )
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[19]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[19]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[19] }}
                      </a>
                    </div>
                  </div>
                </div>

                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div (click)="updateEnableFee()" class="flex justify-between">
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      21. updateEnableFee
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isupdateEnableFeeCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >bool (bool)</label
                      >
                      <input
                        [(ngModel)]="updateEnableFeeBool"
                        name="value"
                        placeholder="true/false (bool)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>

                    <button
                      (click)="
                        setFunctionError(20);
                        writeUpdateEnableFee(updateEnableFeeBool)
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[20]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[20]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[20] }}
                      </a>
                    </div>
                  </div>
                </div>

                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="updateEnableMaxTransactionAmount()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      22. updateEnableMaxTransactionAmount
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isupdateEnableMaxTransactionAmountCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >bool (bool)</label
                      >
                      <input
                        [(ngModel)]="updateEnableMaxTransactionAmountBool"
                        name="value"
                        placeholder="true/false (bool)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>

                    <button
                      (click)="
                        setFunctionError(21);
                        writeUpdateEnableMaxTransactionAmount(
                          updateEnableMaxTransactionAmountBool
                        )
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[21]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[21]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[21] }}
                      </a>
                    </div>
                  </div>
                </div>

                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="updateLiquidityFee()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      23. updateLiquidityFee
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isupdateLiquidityFeeCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >feeInPercentage (uint256)</label
                      >
                      <input
                        [(ngModel)]="updateLiquidityFeeAmount"
                        name="value"
                        placeholder="feeinPercentage (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>

                    <button
                      (click)="
                        setFunctionError(22);
                        writeUpdateLiquidityFee(updateLiquidityFeeAmount)
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[22]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[22]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[22] }}
                      </a>
                    </div>
                  </div>
                </div>

                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="updateLiquidityFeeToSell()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      24. updateLiquidityFeeToSell
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isupdateLiquidityFeeToSellCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >_liquidityFeeToSell (uint256)</label
                      >
                      <input
                        [(ngModel)]="updateLiquidityFeeToSellAmount"
                        name="value"
                        placeholder="_liquidityFeeToSell (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>

                    <button
                      (click)="
                        setFunctionError(23);
                        writeUpdateLiquidityFeeToSell(
                          updateLiquidityFeeToSellAmount
                        )
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[23]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[23]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[23] }}
                      </a>
                    </div>
                  </div>
                </div>

                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="updateMarketingAddress()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      25. updateMarketingAddress
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isupdateMarketingAddressCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >account (address)</label
                      >
                      <input
                        [(ngModel)]="updateMarketingAddressAddress"
                        name="value"
                        placeholder="account (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>

                    <button
                      (click)="
                        setFunctionError(24);
                        writeUpdateMarketingAddress(
                          updateMarketingAddressAddress
                        )
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[24]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[24]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[24] }}
                      </a>
                    </div>
                  </div>
                </div>

                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="updateMarketingFee()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      26. updateMarketingFee
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isupdateMarketingFeeCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >feeInPercentage (uint256)</label
                      >
                      <input
                        [(ngModel)]="updateMarketingFeeAmount"
                        name="value"
                        placeholder="feeInPercentage (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>

                    <button
                      (click)="
                        setFunctionError(25);
                        writeUpdateMarketingFee(updateMarketingFeeAmount)
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[25]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[25]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[25] }}
                      </a>
                    </div>
                  </div>
                </div>

                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="updateMarketingFeeToSell()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      27. updateMarketingFeeToSell
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isupdateMarketingFeeToSellCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >_marketingFeeToSell (uint256)</label
                      >
                      <input
                        [(ngModel)]="updateMarketingFeeToSellAmount"
                        name="value"
                        placeholder="_marketingFeeToSell (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>

                    <button
                      (click)="
                        setFunctionError(26);
                        writeUpdateMarketingFeeToSell(
                          updateMarketingFeeToSellAmount
                        )
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[26]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[26]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[26] }}
                      </a>
                    </div>
                  </div>
                </div>

                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="updateReflectionFee()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      28. updateReflectionFee
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isupdateReflectionFeeCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >feeInPercentage (uint256)</label
                      >
                      <input
                        [(ngModel)]="updateReflectionFeeAmount"
                        name="value"
                        placeholder="feeInPercentage (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>

                    <button
                      (click)="
                        setFunctionError(27);
                        writeUpdateReflectionFee(updateReflectionFeeAmount)
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[27]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[27]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[27] }}
                      </a>
                    </div>
                  </div>
                </div>

                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="updateSwapAndLiquifyEnabled()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      29. updateSwapAndLiquifyEnabled
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isupdateSwapAndLiquifyEnabledCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >bool (bool)</label
                      >
                      <input
                        [(ngModel)]="updateSwapAndLiquifyEnabledBool"
                        name="value"
                        placeholder="true/false (bool)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>

                    <button
                      (click)="
                        setFunctionError(28);
                        writeUpdateSwapAndLiquifyEnabled(
                          updateSwapAndLiquifyEnabledBool
                        )
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[28]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[28]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[28] }}
                      </a>
                    </div>
                  </div>
                </div>

                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="updateTransactionLimit()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      30. updateTransactionLimit
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!isupdateTransactionLimitCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >limitInPercentage (uint256)</label
                      >
                      <input
                        [(ngModel)]="updateTransactionLimitAmount"
                        name="value"
                        placeholder="limitInPercentage (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>

                    <button
                      (click)="
                        setFunctionError(29);
                        writeUpdateTransactionLimit(
                          updateTransactionLimitAmount
                        )
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[29]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[29]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[29] }}
                      </a>
                    </div>
                  </div>
                </div>

                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="withdrawBEP20Token()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      31. withdrawBEP20Token
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!iswithdrawBEP20TokenCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >_tokenContract (address)</label
                      >
                      <input
                        [(ngModel)]="withdrawBEP20TokenAddress"
                        name="value"
                        placeholder="_tokenContract (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >amount (uint256)</label
                      >
                      <input
                        [(ngModel)]="withdrawBEP20TokenAmount"
                        name="value"
                        placeholder="amount (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>

                    <button
                      (click)="
                        setFunctionError(30);
                        writeWithdrawBEP20Token(
                          withdrawBEP20TokenAddress,
                          withdrawBEP20TokenAmount
                        )
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[30]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[30]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[30] }}
                      </a>
                    </div>
                  </div>
                </div>

                <div
                  class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700"
                >
                  <div
                    (click)="withdrawNativeFromContract()"
                    class="flex justify-between"
                  >
                    <h2
                      class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg"
                    >
                      32. withdrawNativeFromContract
                    </h2>
                    <img
                      src="assets/landing-new/icons/arrow-right-violet.svg"
                      class="cursor-pointer"
                      alt=""
                    />
                  </div>
                  <div
                    [@collapse]="!iswithdrawNativeFromContractCollapsed"
                    class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider"
                  >
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >user (address)</label
                      >
                      <input
                        [(ngModel)]="withdrawNativeAddress"
                        name="value"
                        placeholder="user (address)"
                        class="input--field__md"
                        type="text"
                      />
                    </div>
                    <div>
                      <label for="value" class="input--label__md mb-1"
                        >amount (uint256)</label
                      >
                      <input
                        [(ngModel)]="withdrawNativeAmount"
                        name="value"
                        placeholder="amount (uint256)"
                        class="input--field__md"
                        type="number"
                      />
                    </div>

                    <button
                      (click)="
                        setFunctionError(31);
                        writeWithdrawNativeFromContract(
                          withdrawNativeAddress,
                          withdrawNativeAmount
                        )
                      "
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4"
                    >
                      {{functionProcessing[31]}}
                    </button>
                    <button
                      *ngIf="showViewTransaction[31]"
                      (click)="openTXPage()"
                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4 ml-4"
                    >
                      View Transaction
                    </button>
                    <div>
                      <a
                        class="text-[#d9d9d9] hover:text-primary-light hover:underline text-sm md:text-base ep--font-light mt-4 block"
                      >
                        {{ functionError[31] }}
                      </a>
                    </div>
                  </div>
                </div>

                <!-- <div  *ngFor="let fun of readFunction;index as i"
                          class="col-span-12 cursor-pointer animate-slide space-y-4 bg-[#3030301a] border border-solid border-[#191A1E] p-6 rounded-lg transition ease-in-out duration-700">
                          <div class="flex justify-between">
                              <h2 class="text-[#d9d9d9] ep--font-light text__yg--gradient text-sm md:text-base xl:text-lg">{{fun}}
                              </h2>
                              <img src="assets/landing-new/icons/arrow-right-violet.svg" class="cursor-pointer"
                                  alt="">
                          </div>
                          <div [@collapse]="i==i"
                                  class="text-[#D9D9D9] space-y-4 text-sm lg:text-base ep--font-light lg:!leading-[1.75] tracking-wider">
                                  <div>
                                      <label for="amount" class="input--label__md mb-1">_blackListedUser
                                          (address)</label>
                                      <input name="amount" placeholder="_blackListedUser (address)"
                                          class="input--field__md" type="text">
                                  </div>
                                  <button
                                      class="lg:text-sm p-2 px-4 rounded-md text-xs bg-[#4E1FA3]/30 border border-[#4e1fa3] border-solid font-medium text-white mt-4">Write</button>
                              </div>

                      </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
<div class="fixed z-[60] inset-0 overflow-y-auto" [ngClass]="!isMetamaskConnected  ? 'block' : 'hidden'"
    aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="flex items-center md:items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div class="fixed inset-0 bg-[#0f172acc] backdrop-blur-md transition-opacity" aria-hidden="true"></div>
        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
        <div
            class="relative inline-block align-bottom bg-secondary-dark shadow-md p-6 rounded-xl text-left overflow-hidden transform transition-all sm:my-8 sm:align-middle sm:max-w-3xl sm:w-[28rem] token-create-success">
            <div class="grid grid-cols-12 gap-4 gap-y-6 sm:gap-6 lg:gap-8 mt-4">
                <div class="col-span-12 relative">
                    <h2 class="font-bold text-white text-xl lg:text-2xl text-center">Connect wallet to explore</h2>
                    <div class="text-center py-8">
                        <div
                            class="border-2 border-solid border-primary bg-secondary-dark p-4 rounded-full inline-block gradient-border">
                            <img src="assets/icons/connect-wallet.svg" class="w-8 h-8 m-2" alt="">
                        </div>
                    </div>
                    <button (click)="connectWallet()" type="Button" class="btn__primary--sm rounded-lg w-full">
                        Connect Wallet
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
